import { Component } from '@angular/core';
import { Filters } from 'src/app/models/filters.model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { SearcherService } from 'src/app/services/searcher.service';
import { concatMap, tap, shareReplay, catchError, finalize } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'page-full-screen-calendar',
  templateUrl: 'full-screen-calendar.html',
  styleUrls: ['full-screen-calendar.scss']
})
export class FullScreenCalendarPage {
  public itemType: string = 'calendar';
  public filters$: BehaviorSubject<Filters> = new BehaviorSubject({
    searchKey: '',
    start: 0,
    length: 20
  });
  page$: Observable<any>;
  private pageId: number;
  /** Keeps toolbar + item-searcher mounted on back navigation until page$ emits again */
  public latestPage: any = null;

  private $event;
  public forbidden: boolean = false;
  public listLoading = true;
  public readonly listSkeletonPlaceholders = [1, 2, 3];

  constructor(
    public router: Router,
    private analyticsService: AnalyticsService,
    private searcherService: SearcherService,
    private route: ActivatedRoute
  ) {}

  ionViewWillEnter() {
    this.listLoading = true;

    const nextPageId = +this.route.snapshot.paramMap.get('idPage');
    if (this.pageId !== undefined && nextPageId !== this.pageId) {
      this.latestPage = null;
    }
    this.pageId = nextPageId;

    this.page$ = this.filters$.pipe(
      concatMap((filters) =>
        this.searcherService
          .allItems(
            `${Environment.API_BASE_URL_V2}/api/empatica/v1/components/events/${this.pageId}/elements`,
            filters,
            this.itemType
          )
          .pipe(finalize(() => (this.listLoading = false)))
      ),
      tap(() => this.$event && this.$event.target.complete && this.$event.target.complete()),
      tap((response) => {
        this.latestPage = response;
      }),
      tap(() => (this.forbidden = false)),
      catchError((err: any) => {
        if (err.status === 403) {
          this.forbidden = true;
        }

        throw err;
      }),
      shareReplay()
    );

    this.registerAnalyticsInFirebase();
    this.getAllItems({ filters: { ...this.filters$.value, start: 0 } });
  }

  goToDetail($event) {
    const article = $event.item;
    this.router.navigate([`calendar/${this.pageId}/detail/${article.id}`]);
  }

  private registerAnalyticsInFirebase() {
    const paramsToAnalytics = { navigation: 2 };
    this.analyticsService.registerEvent(paramsToAnalytics, 'Screen calendar', this.pageId);
  }

  public getAllItems({ filters, event = null }) {
    if (event) this.$event = event;
    this.filters$.next(filters);
  }

  public goToAddItem(id) {
    this.router.navigate([`calendar/${id}/add`]);
  }
}
